export default "__VITE_PUBLIC_ASSET__aabb5a6e__"